export const DIVISIONS_WITH_REGIONAL_RANKING = ['NCAA Division II'];
export const DIVISIONS_WITH_DIVISIONAL_RANKING = ['NJCAA I', 'NJCAA II'];
export const DIVISION_I = 'NCAA Division I';
